import styled from 'styled-components';

export const ModalContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const ModalBody = styled.div`
	display: grid;
	gap: 16px;
	width: 100%;
`;

export const Steps = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 12px;
	font-weight: 500;
	line-height: 12px;
	text-align: center;
	text-transform: uppercase;
`;

export const Title = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 20px;
	font-weight: 500;
	line-height: 30px;
	margin-bottom: 8px;
	text-align: center;
`;

export const TitleSpan = styled.span`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 20px;
	font-weight: 500;
	line-height: 30px;
`;

export const TitleSection = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 12px;
	line-height: 12px;
	margin: 0 0 8px;
`;

export const Subtitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-weight: 400;
	line-height: 18px;
	margin-bottom: 32px;
	text-align: center;

	a {
		text-decoration: underline;
	}
`;

export const ModalFooter = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	gap: 8px;
	justify-content: center;
	margin-top: 32px;
	width: 100%;

	button {
		height: 48px;
		width: 100%;
	}
`;

export const Text = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 18px;
	font-weight: 400;
	line-height: 1.2;
	text-align: center;
`;

export const Button = styled.button`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.extra.crab};
	border: none;
	border-radius: 8px;
	color: ${({ theme }) => theme.colors.principal.pure};
	cursor: pointer;
	display: flex;
	flex-direction: row;
	justify-content: center;
	outline: none;
	padding: 8px 14px;

	svg {
		margin-right: 12px;
	}

	&:disabled {
		cursor: default;
		opacity: 0.2;
		pointer-events: none;
	}
`;

export const SectionCardsContainer = styled.section`
	display: grid;
	gap: 16px;
	grid-template-columns: 1fr 1fr;
	height: 100%;
	width: 100%;

	/* media querie
	 */
	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		grid-template-columns: 1fr;
	}
`;

interface PLCardContainerProps {
	selected: boolean;
	onStart?: boolean;
}

export const PLCardContainer = styled.article<PLCardContainerProps>`
	background-color: ${({ theme }) => theme.colors.principal.pure};
	border: 1px solid;

	border-color: ${(props) =>
		props.selected ? props.theme.colors.principal.vanth : props.theme.colors.principal.ceres};
	border-radius: 12px;
	cursor: pointer;
	height: 120px;
	padding: 16px;
	position: relative;
	width: 100%;
`;

export const IconWrapper = styled.div`
	border-radius: 50%;
	position: absolute;
	right: 8px;
	top: 8px;

	svg {
		height: 24px;
		width: 24px;
	}
`;

export const PLContent = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: 6px;
	justify-content: center;
`;

export const PLCardIcon = styled.div<PLCardContainerProps>`
	align-items: center;
	background-color: ${(props) =>
		props.selected ? props.theme.colors.principal.wasp : props.theme.colors.principal.air};
	border-radius: 50%;
	display: flex;
	height: 43px;
	justify-content: center;
	width: 43px;
`;

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	text-align: center;
	width: 144px;
`;

export const PLCardTitle = styled.h1<PLCardContainerProps>`
	color: ${(props) =>
		props.selected ? props.theme.colors.principal.orion : props.theme.colors.principal.vanth};
	font-family: ${({ theme }) => theme.fonts.stack};
	font-size: 14px;
	font-weight: 400;
	${(props) => props.onStart && 'align-self: flex-start;'}

	span {
		cursor: pointer;
		text-decoration: underline;
	}
`;

export const PLCardSubtitle = styled.p<PLCardContainerProps>`
	color: ${(props) =>
		props.selected ? props.theme.colors.principal.orion : props.theme.colors.principal.vanth};
	font-family: ${({ theme }) => theme.fonts.stack};
	font-size: 11px;
	font-weight: 400;
	line-height: 13px;
`;

export const ContainerInputsForm = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;

export const ContainerInput = styled.div`
	width: 100%;

	input {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;

		&:read-only {
			background-color: #f7f6ff;
			border: none;
			padding-right: 70px;
		}
	}
`;

export const CopyButton = styled.span`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.extra.crab};
	border-radius: 4px;
	color: ${({ theme }) => theme.colors.principal.pure};
	display: flex;
	font-size: 12px;
	font-weight: 400;
	height: 28px;
	justify-content: center;
	line-height: 12px;
	padding: 6px;
`;

export const TabsContainer = styled.div`
	margin-top: 32px;
	width: 100%;
`;

export const TabBody = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const QRTitle = styled.p`
	align-items: center;
	color: ${({ theme }) => theme.colors.principal.orion};
	display: flex;
	font-size: 20px;
	font-weight: 500;
	line-height: 30px;
	margin: 0;
	text-align: center;
`;

export const QRSubtitle = styled.p`
	align-items: center;
	color: ${({ theme }) => theme.colors.principal.vanth};
	display: flex;
	font-size: 18px;
	font-weight: 400;
	line-height: 28px;
	margin: 0;
	text-align: center;
`;

export const QRCodeContainer = styled.div`
	background-color: #f7f7ff;
	border-radius: 12px;
	margin: 16px 0;
	padding: 23px;

	img {
		height: 114px;
		width: 114px;
	}
`;

export const ScanQRText = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
`;

export const ShareView = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: 12px;
	justify-content: center;
	width: 100%;

	button {
		height: 48px;
		width: 100%;
	}
`;

export const BackButtonContainer = styled.div`
	align-items: center;
	align-self: flex-start;
	cursor: pointer;
	display: flex;
	margin-bottom: 24px;
	width: fit-content;

	svg {
		height: 12px;
		stroke: ${({ theme }) => theme.colors.principal.vanth};
	}
`;

export const BackText = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 14px;
	font-weight: 400;
	line-height: 21px;
	margin-left: 10px;
`;

export const SendLinkButtonContainer = styled.div`
	margin-top: 24px;
	width: 100%;

	button {
		align-items: center;
		display: flex;
		height: 48px;
		width: 100%;
	}
`;

export const PaymentTypeSection = styled.div`
	display: flex;
	gap: 16px;
	justify-content: space-between;
`;

export const HintInput = styled.p`
	color: ${({ theme }) => theme.colors.principal.moon};
	font-size: 14px;
	font-weight: 400;
	line-height: 13px;
	margin-top: 6px;
	width: 100%;
`;

interface HintWithActionProps {
	showingConfig: boolean;
}

export const HintWithAction = styled.p<HintWithActionProps>`
	color: ${({ theme, showingConfig }) => theme.colors.principal[showingConfig ? 'moon' : 'vanth']};
	font-size: 12px;
	font-weight: 400;
	line-height: 12px;
	margin-top: 6px;
	width: 100%;

	span {
		cursor: pointer;
		margin-left: 4px;
		text-decoration: underline;
	}
`;

export const ContainerFilterTime = styled.div`
	display: grid;
	gap: 16px;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	position: relative;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		grid-template-columns: 1fr;
	}
`;

interface PaymentTypeContainerProps {
	isDisabled: boolean;
	isSelected: boolean;
}

export const PaymentTypeContainer = styled.div<PaymentTypeContainerProps>`
	align-items: center;
	background-color: ${({ theme, isDisabled }) =>
		theme.colors.principal[isDisabled ? 'eris' : 'pure']};
	border: 1px solid
		${({ theme, isSelected }) => theme.colors.principal[isSelected ? 'vanth' : 'ceres']};
	border-radius: 12px;
	cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 18px 13px;
	pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
	position: relative;
	text-align: center;
	width: 100%;
`;

export const ComingSoonContainer = styled.div`
	align-items: center;
	background-color: #fcfcfc;
	border-radius: 3px;
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 8px;
	line-height: 12px;
	padding: 3px;
`;

export const SelectedIconContainer = styled.div`
	position: absolute;
	right: 3px;
	top: 3px;
`;

interface IconContainerProps {
	show: boolean;
	isSelected: boolean;
}

export const IconContainer = styled.div`
	align-items: center;
	border: 1px solid
		${({ theme, isSelected }) => theme.colors.principal[isSelected ? 'orion' : 'vanth']};
	border-radius: 50%;
	display: flex;
	height: 45px;
	justify-content: center;
	opacity: ${({ show }: IconContainerProps) => (show ? 1 : 0)};
	width: 45px;
`;

interface TextsProps {
	isSelected: boolean;
}

export const PaymentTypeTitle = styled.p<TextsProps>`
	color: ${({ theme, isSelected }) => theme.colors.principal[isSelected ? 'orion' : 'vanth']};
	font-size: 14px;
	line-height: 21px;
	margin-top: 8px;
`;

export const PaymentTypeSubTitle = styled.p<TextsProps>`
	color: ${({ theme, isSelected }) => theme.colors.principal[isSelected ? 'orion' : 'vanth']};
	font-size: 11px;
	line-height: 13px;
`;

export const InputContainer = styled.div`
	position: relative;
	width: 100%;
`;

interface ChangeMonthContainerProps {
	readonly allowClick: boolean;
}

export const ChangeMonthContainer = styled.div<ChangeMonthContainerProps>`
	cursor: ${({ allowClick }) => (allowClick ? 'pointer' : 'default')};
	display: flex;
	padding: 4px;

	svg {
		path {
			stroke: ${({ theme, allowClick }) => theme.colors.principal[allowClick ? 'orion' : 'moon']};
		}
	}
`;

export const HeaderMonthYearSelected = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
`;

export const CurrentMonthYear = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;

	&::first-letter {
		text-transform: uppercase;
	}
`;

interface ShowDatePickerContainerProps {
	y: 'top' | 'bottom';
	x: 'left' | 'right';
}

export const ShowDatePickerContainer = styled.div<ShowDatePickerContainerProps>`
	background-color: ${({ theme }) => theme.colors.principal.pure};
	border: 1px solid #e6e6e6;
	border-radius: 6px;
	bottom: ${({ y }) => (y === 'top' ? '225px' : 'inherit')};
	left: ${({ x }) => (x === 'left' ? '25px' : 'inherit')};
	padding: 24px 16px;
	position: absolute;
	right: ${({ x }) => (x === 'right' ? '0' : 'inherit')};
	top: ${({ y }) => (y === 'bottom' ? '50px' : 'inherit')};
	z-index: 20;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		bottom: inherit;
		max-width: 260px;
		padding: 10px;
		top: 0;
	}

	.react-datepicker {
		border: 0;
		border-bottom: 1px solid ${({ theme }) => theme.colors.principal.ceres};
		padding-bottom: 20px;
		width: 100%;
	}

	.react-datepicker__header {
		background-color: transparent;
		border-bottom: 0;
		padding-top: 0;
	}

	.react-datepicker__month-container {
		display: flex;
		flex-direction: column;
		float: initial;
		font-size: 14px;
		width: 100%;

		.react-datepicker__month {
			@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
				width: 100%;
			}
		}
	}

	.react-datepicker__day-name {
		align-items: center;
		aspect-ratio: 1/1;
		color: ${({ theme }) => theme.colors.principal.orion};
		font-size: 14px;
		font-weight: 500;
		line-height: 21px;
		margin: 0;
		text-align: center;
		width: 40px;

		&::first-letter {
			text-transform: uppercase;
		}

		@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
			width: 100%;
		}
	}

	.react-datepicker__day--outside-month,
	.react-datepicker__day--disabled {
		color: ${({ theme }) => theme.colors.principal.moon} !important;
	}

	.react-datepicker__month {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 0;
		margin-top: 15px;
		width: min-content;
	}

	.react-datepicker__week,
	.react-datepicker__day-names {
		display: grid;
		grid-template-columns: repeat(7, 1fr);

		@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
			width: 100%;
		}
	}

	.react-datepicker__day {
		align-items: center;
		aspect-ratio: 1/1;
		border-radius: 50%;
		color: ${({ theme }) => theme.colors.principal.vanth};
		display: flex;
		font-size: 14px;
		font-weight: 400;
		justify-content: center;
		line-height: 21px;
		margin: 0;
		position: relative;
		text-align: center;
		transition: background-color 0.2s ease-in-out;
		width: 40px;

		&:not(.react-datepicker__day--disabled):not(.react-datepicker__day--today):hover {
			background-color: ${({ theme }) => theme.colors.principal.ceres};
		}

		@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
			width: 100%;
		}
	}

	.react-datepicker__day--keyboard-selected {
		background-color: ${({ theme }) => theme.colors.principal.pure};
		border: 1px dashed ${({ theme }) => theme.colors.principal.ceres};
	}

	.react-datepicker__day--today {
		background-color: ${({ theme }) => theme.colors.principal.pure};
		border: 1px solid ${({ theme }) => theme.colors.principal.orion};
		border-radius: 24px;
	}

	.react-datepicker__day--in-range,
	.react-datepicker__day--selected,
	.react-datepicker__day--in-selecting-range {
		border-radius: 0;

		&:not(.react-datepicker__day--disabled) {
			background-color: rgba(20 15 51 / 10%) !important;
			border: 1px solid transparent !important;
			color: ${({ theme }) => theme.colors.principal.orion} !important;
		}
	}

	.react-datepicker__day--range-start,
	.react-datepicker__day--selecting-range-start {
		border-radius: 50%;

		&:not(.react-datepicker__day--range-end):not(.react-datepicker__day--selecting-range-end) {
			border-radius: 24px 0 0 24px !important;
		}
	}

	.react-datepicker__day--range-end,
	.react-datepicker__day--selecting-range-end {
		&:not(.react-datepicker__day--range-start):not(.react-datepicker__day--selecting-range-start) {
			border-radius: 50%;

			&::before {
				aspect-ratio: 1/1;
				background-color: rgba(20 15 51 / 10%);
				border: 0;
				border-radius: 0 24px 24px 0;
				content: '';
				height: 105%;
				position: absolute;
				width: inherit;
			}
		}
	}

	.react-datepicker__day--range-end,
	.react-datepicker__day--selecting-range-end {
		&:not(.react-datepicker__day--in-selecting-range) {
			background-color: ${({ theme }) => theme.colors.principal.orion} !important;
			color: ${({ theme }) => theme.colors.principal.pure} !important;
		}
	}

	.react-datepicker__day--selected {
		&:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
			background-color: ${({ theme }) => theme.colors.principal.orion} !important;
			border-radius: 50%;
			color: ${({ theme }) => theme.colors.principal.pure} !important;
		}
	}
`;

export const DatePickerHeader = styled.div`
	color: ${({ theme }) => theme.colors.principal.orion};
	display: flex;
	font-size: 16px;
	font-weight: 400;
	gap: 12px;
	justify-content: space-evenly;
	line-height: 18px;
	margin-bottom: 25px;
	margin-left: auto;
	margin-right: auto;
	width: 80%;
`;
